// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import useProviderServices from '@hooks/queries/registry/onboarding/useProviderServices';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

interface ProviderSelectProps {
  onChange: (provider: string) => void;
  selectedProvider?: string;
  onInputChange: (newInput: string) => void;
}
export const ProviderSelect: React.FC<ProviderSelectProps> = ({
  onInputChange,
  onChange,
  selectedProvider,
}) => {
  const providerServices = useProviderServices();
  const { isLoading, data } = providerServices;
  const providers = data?.map((p) => p.payload.provider) || [];
  return (
    <Autocomplete
      size="small"
      loading={isLoading}
      freeSolo
      options={providers}
      value={selectedProvider}
      onInputChange={(_, newInputValue) => onInputChange(newInputValue)}
      renderInput={(params) =>
        isLoading ? (
          <CircularProgress size={20} />
        ) : (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <TextField placeholder="Provider" {...params} />
        )
      }
      onChange={(_, newValue) => {
        onChange(newValue as string);
      }}
    />
  );
};
